import { ACTIONS, THEME } from '../config/ondsConfig'

const TONE_COLOR = {
  bull: THEME.bull,
  bear: THEME.bear,
  caution: THEME.caution,
  neutral: THEME.neutral,
}

export const toneColor = (tone) => TONE_COLOR[tone] ?? THEME.neutral

export const actionMeta = (key) =>
  Object.values(ACTIONS).find((a) => a.key === key) ?? ACTIONS.HOLD

export const actionColor = (key) => toneColor(actionMeta(key).tone)

export const impactTone = (impact) => {
  if (impact === 'bullish') return 'bull'
  if (impact === 'bearish') return 'bear'
  return 'neutral'
}

export const convictionTone = (value) => {
  if (value >= 0.7) return 'bull'
  if (value >= 0.5) return 'caution'
  return 'bear'
}
